module.exports = __webpack_public_path__ + "static/img/apply-a.b6092c37.png";